var moduleMap = {
	"./router": () => {
		return Promise.all([__webpack_require__.e(53), __webpack_require__.e(12), __webpack_require__.e(83), __webpack_require__.e(35), __webpack_require__.e(988), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(833), __webpack_require__.e(542), __webpack_require__.e(896), __webpack_require__.e(625)]).then(() => (() => ((__webpack_require__(9625)))));
	},
	"./DocsIndex": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(542), __webpack_require__.e(242)]).then(() => (() => ((__webpack_require__(2242)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});